export default "__VITE_ASSET__DA6ay8P9__"